export enum PAYOUT_PRESET {
  ADDITIONAL_BRIEF_PAYMENT = 'Additional Brief Payment',
  EXPEDITED_SUBMISSION_PAYMENT = 'Expedited Submission Payment',
  META_EARNINGS = 'Meta Earnings',
  TIKTOK_EARNINGS = 'TikTok Earnings',
  YOUTUBE_EARNINGS = 'Youtube Earnings',
  PRODUCT_PASSTHROUGH = 'Product Purchase Passthrough',
  REFERRAL_BONUS = 'Referral Bonus',
  TOTAL_EARNINGS = 'Total Earnings',
  WHITELISTING = 'Whitelisting',
}
